export default __webpack_public_path__ + "static/media/GamesGlobal.e42f1f5d.jpg";